require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./vivre-lausanne-1-13-1.json") })
        }
      }, "path---vivre-lausanne-1-13-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---vivre-lausanne-1-13-1!./.cache/json/vivre-lausanne-1-13-1.json
// module id = 609
// module chunks = 231608221292675